import appStore from './ja-JP/app-store';
import applicationCatalog from './ja-JP/application-catalog';
import applicationCenter from './ja-JP/application-center';
import applicationFeedback from './ja-JP/application-feedback';
import businessAppMarket from './ja-JP/business-app-market';
import component from './ja-JP/component';
import globalHeader from './ja-JP/globalHeader';
import markets from './ja-JP/markets';
import menu from './ja-JP/menu';
import myApps from './ja-JP/my-apps';
import navigation from './ja-JP/navigation';
import pages from './ja-JP/pages';
import platformSettings from './ja-JP/platform-settings';
import pwa from './ja-JP/pwa';
import settingDrawer from './ja-JP/settingDrawer';
import settings from './ja-JP/settings';
import workbench from './ja-JP/workbench';

export default {
  'navBar.lang': '言語',
  'layout.user.link.help': 'ヘルプ',
  'layout.user.link.privacy': 'プライバシー',
  'layout.user.link.terms': '利用規約',
  'app.footer.copyright': '2026 Coral Wisdom (Beijing) Technology Co., Ltd.',
  'app.preview.down.block':
    'このページをローカルプロジェクトにダウンロードしてください',
  'app.workbench.link.fetch-blocks': '',
  'app.workbench.link.block-list': '',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...navigation,
  ...workbench,
  ...applicationCatalog,
  ...applicationCenter,
  ...applicationFeedback,
  ...businessAppMarket,
  ...markets,
  ...myApps,
  ...appStore,
  ...platformSettings,
};
